module.exports = __webpack_public_path__ + "images/311136771148a03e0cc26b884452cc513409.svg";